import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const panelVariants = {
    hidden: {
        opacity: 0,
        scale: 0.4,
        borderRadius: '50%',
        y: 40,
    },
    visible: {
        opacity: 1,
        scale: 1,
        borderRadius: '12px',
        y: 0,
        transition: {
            type: 'spring',
            stiffness: 280,
            damping: 26,
            opacity: { duration: 0.15, ease: 'easeOut' },
            borderRadius: { duration: 0.35, ease: 'easeOut' },
        },
    },
    exit: {
        opacity: 0,
        scale: 0.4,
        borderRadius: '50%',
        y: 40,
        transition: {
            type: 'spring',
            stiffness: 300,
            damping: 30,
            opacity: { duration: 0.15, ease: 'easeIn' },
        },
    },
};

const ResizableModal = ({ isOpen, onClose, children }) => {
    return (
        <AnimatePresence>
            {isOpen && (
                <>
                    {/* Subtle backdrop — no dark overlay, just click-to-close */}
                    <motion.div
                        key="backdrop"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.2 }}
                        onClick={onClose}
                        className="fixed inset-0 z-[100]"
                    />

                    {/* Chat panel — expands from the button (bottom-right) */}
                    <motion.div
                        key="panel"
                        variants={panelVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        style={{ transformOrigin: 'bottom right' }}
                        onClick={(e) => e.stopPropagation()}
                        className="fixed top-[132px] bottom-6 right-4 w-full max-w-[520px] z-[101] flex flex-col overflow-hidden shadow-2xl"
                    >
                        {children}
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
};

export default ResizableModal;
